/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/prop-types */
import React, { Fragment } from "react";
import Divider from '@material-ui/core/Divider';
import { withStyles } from "@material-ui/styles";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
  CircularProgress,
} from "@material-ui/core";

import LoginMenu from '../../../../components/LoginMenu/LoginMenu';
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { useDropzone } from "react-dropzone";
import UploadDocumentsTable from './UploadDocumentsTable';


const useStyles = (theme) => ({
  downShift: {
    paddingTop: "18px !important",
  },
  textFieldCard: {
    paddingTop: "0px !important",
  },
  cardcontent: {
    paddingTop: "0px !important",
    paddingLeft: "4px",
    paddingRight: "4px",
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[200],
    fontSize: "2px !important",
    padding: "8px !important",
  },
  asdf: {
    margin: 1000,
  },
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,

    marginRight: 20,
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },

  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  bigAvatar: {
    margin: 10,
  },
  badgeMargin: {
    margin: theme.spacing.unit * 2,
  },
  inline: {
    display: "inline",
  },
  card: {
    marginLeft: "10px",
    marginRight: "10px",
    marginTop: "10px",
  },
  formControl: {
    minWidth: "100%",

  },
  container: {
    marginTop: "100px",
  },
});


function MyDropzone(props) {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  const files = acceptedFiles.map((file, index) => {
    const size = file.size > 0 ? (file.size / 1000).toFixed(2) : file.size;
    return (
      <Typography key={index} variant="subtitle1" color="primary">
        {file.path} - {size} Kb
        <input type="hidden" name="file_name" value={file.path}></input>
      </Typography>
    )
  });

  let msg = files || [];
  if (msg.length <= 0 || props.files.length <= 0) {
    msg = <Typography variant="subtitle1">
      Please click to select a file or drop your file here
  </Typography>;
  }
  return (
    <div
      style={{ textAlign: "center" }}
      {...getRootProps({ className: "dropzone", onChange: event => props.onChange(event) })}
    >
      <Card style={{ backgroundColor: "#c7c7c7" }}>
        <CardContent style={{
          paddingBottom: 18
        }}>
          <input name="contained-button-file" {...getInputProps()} disabled={props.disabled} />
          {msg}

        </CardContent>
      </Card>
    </div>
  );
}
class UploadDocumentsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

      documentData: [],
      documentList: [],

      documentTypeId: "",
      documentTypeIdError: "",
      files: [],
      filesError: "",

      remarks: "",
      requestId: "",

      isLoading: false,
      isUploading: false,
      isLoginMenu: false,
      isReload: false,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    this.setState({
      isLoading: true
    })
    await this.getDocumentListData();
    await this.getData();

    this.setState({
      isLoading: false
    })
  };

  getData = async () => {
    let url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C17AdmissionsProspectApplicationUploadedDocumentsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (result) => {
          if (result.CODE === 1) {
            this.setState({
              documentData: result.DATA || []
            })
          } else {
            alert(result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE)
          }
        },
        (error) => {
          alert("Operation Failed, Please try again later");
          console.log(error);
        }
      );
  };

  getDocumentListData = async () => {
    let url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C17AdmissionsProspectApplicationRaisedDocumentsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            this.setState({
              documentList: json.DATA || [],
            });
          } else {
            alert(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE);
          }
        })
      .catch((error) => {
        if (error.status == 401) {
          this.setState({
            isLoginMenu: true,
            isReload: true
          })
        } else {
          alert('Operation Failed, Please try again later.');
        }
        console.log(error);
      });
  }

  isFormValid = () => {
    let { documentTypeIdError, filesError } = this.state;
    let isValid = true;
    if (!this.state.documentTypeId) {
      isValid = false
      documentTypeIdError = "Please select document type.";
    }
    if (this.state.files.length <= 0) {
      isValid = false;
      filesError = "Please select a file."
    }
    this.setState({
      filesError,
      documentTypeIdError
    })
    return isValid;
  }

  handleSubmitButtonClick = () => {
    const isValid = this.isFormValid();
    if (isValid) {
      document.getElementById("submit-button").click();
    }
    return;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({
      isUploading: true
    });
    const data = new FormData(e.target);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C17AdmissionsProspectApplicationDocumentsUpload`;
    await fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then((result) => {
        if (result.CODE == 1) {
          this.setState({
            documentTypeId: "",
            documentTypeIdError: "",
            files: [],
            filesError: "",
            requestId: "",
            remarks: ""
          })
          this.loadData();
        } else {
          alert(result.CODE + ":" + result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE);
        }
      })
      .catch((error) => {
        if (error.status == 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false
          })
        } else {
          alert('Operation Failed, Please try again later.');
          console.log(error);
        }
      });
    this.setState({
      isUploading: false,
    });
  };

  DownloadFile = (fileName) => {
    const data = new FormData();
    data.append("fileName", fileName);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${
      process.env.REACT_APP_SUB_API_NAME
      }/common/CommonViewFile?fileName=${encodeURIComponent(fileName)}`;

    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (res.status === 200) {
          return res.blob();
        } else if (res.status == 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false
          })
          return {}
        } else {
          alert('Operation Failed, Please try again later.');
          return {}
        }
      })
      .then((result) => {
        var csvURL = window.URL.createObjectURL(result);
        var tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute("download", fileName);
        tempLink.click();
        console.log(csvURL);
        if (result.CODE == 1) {
          //Code
        } else if (result.CODE == 2) {
          alert(
            "SQL Error (" +
            result.CODE +
            "): " +
            result.USER_MESSAGE +
            "\n" +
            result.SYSTEM_MESSAGE
          );
        } else if (result.CODE == 3) {
          alert(
            "Other Error (" +
            result.CODE +
            "): " +
            result.USER_MESSAGE +
            "\n" +
            result.SYSTEM_MESSAGE
          );
        } else if (result.error == 1) {
          alert(result.error_message);
        } else if (result.success == 0 && result.redirect_url != "") {
          window.location = result.redirect_url;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  deleteFile = (id) => {
    const data = new FormData();
    data.append("documentId", id);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C17AdmissionsProspectApplicationDocumentsDelete`;
    fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (result) => {
          console.log(result);
          if (result["CODE"] == 1) {
            this.loadData();
          } else {
            alert(result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE);
          }
        })
      .catch((error) => {
        if (error.status == 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false
          })
        } else {
          alert('Operation Failed, Please try again later.');
          console.log(error);
        }
      });
  };

  handleFileChange = event => {
    const { files = [] } = event.target;
    console.log(files);
    this.setState({
      files,
      filesError: ""
    })

  }

  handleChange = (e) => {

    let { remarks = "", requestId = "" } = this.state;
    const { name, value } = e.target;
    const errName = `${name}Error`;

    if (name === "documentTypeId") {
      const findObj = this.state.documentList.find(item => item.documentTypeId === value);
      remarks = findObj.remarks || "";
      requestId = findObj.id || "";

    }

    this.setState({
      [name]: value,
      [errName]: "",
      remarks,
      requestId
    })
  }

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <LoginMenu reload={this.state.isReload} open={this.state.isLoginMenu} handleClose={() => this.setState({ isLoginMenu: false })} />
        <div className={classes.root}>
          <div
            style={{
              marginTop: "15px",
              marginBottom: "60px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ width: "96%" }}>
              <form
                id="myform"
                onSubmit={this.handleSubmit}
                autoComplete="off"
              >
                <input type="hidden" name="requestId" value={this.state.requestId} />
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <div style={{ padding: 10 }}>
                      <Typography
                        style={{
                          color: "#1d5f98",
                          fontWeight: 600,
                          fontSize: 20,
                        }}
                        variant="h5"
                      >
                        Upload Documents
                    </Typography>
                      <Divider />
                      <br></br>
                      <Typography
                        style={{ fontSize: 14, paddingTop: "20px" }}
                        variant="p"
                      >
                        Please upload following documents

                      </Typography>
                    </div>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    style={{ paddingLeft: 20, paddingRight: 20 }}
                  >
                    <TextField
                      name="documentTypeId"
                      fullWidth
                      label="Document Type"
                      value={this.state.documentTypeId}
                      onChange={this.handleChange}
                      required
                      error={this.state.documentTypeIdError}
                      select
                    >
                      {this.state.documentList.map((item, index) => {
                        return (
                          <MenuItem key={index} value={item.documentTypeId}>
                            {item.documentTypeLabel}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                    {this.state.remarks &&
                      <div style={{
                        marginTop: 10
                      }}>
                        <b>Remarks: </b> {this.state.remarks}
                      </div>
                    }
                    <div>&nbsp;</div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={11}
                    style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10 }}
                  >

                    <MyDropzone files={this.state.files} onChange={event => this.handleFileChange(event)} disabled={this.state.isUploading} />
                    <div style={{
                      textAlign: 'center',
                      marginTop: 10
                    }}>
                      <span style={{
                        color: '#ff2d2d'
                      }}>{this.state.filesError}</span>
                    </div>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={1}
                    style={{
                      paddingTop: 10,
                      marginTop: 10,
                    }}
                  >
                    <input
                      id="submit-button"
                      type="submit"
                      style={{ display: "none" }}
                    />
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      className={classes.submit}
                      style={{ width: 75, height: 40 }}
                      onClick={() => this.handleSubmitButtonClick()}
                      disabled={this.state.isUploading}
                    >
                      {this.state.isUploading ? (
                        <CircularProgress style={{ color: "white" }} size={24} />
                      ) : (
                          "Upload"
                        )}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10 }}
                  >
                    <UploadDocumentsTable type={1} rows={this.state.documentData}
                      columns={[
                        { key: "documentTypeLabel", label: "Document Type", style: { width: '60%' } },
                        { key: "uploadedOn", label: "Upload Date", style: { width: '20%' } }
                      ]} onDownload={name => this.DownloadFile(name)} onDelete={id => this.deleteFile(id)} />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 20 }}
                  >
                    <Typography
                      style={{ color: "#1d5f98", fontWeight: 600, fontSize: 16, fontStyle: 'italic' }}
                      variant="h5"
                    >
                      Reference Letter (not applicable to Bloomfield Hall School
                      or UCL students)
                  </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 0 }}
                  >
                    <Typography style={{ fontSize: 14, paddingTop: "20px" }} variant="p">
                      Please ask your referee to email us your reference letter at <a href="mailto:admissions@ucl.edu.pk">admissions@ucl.edu.pk</a><b> within 5 working days</b> of submission of your admission application. Your Full Name, Applicant ID and the Programme you Applied for should be mentioned in the email.
                </Typography>
                  </Grid>
                </Grid>
              </form>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default withStyles(useStyles)(UploadDocumentsForm);
